function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "increase-level",
  d: "M33.774,4.5l-7.506,5.63v9.758l-4.5-3.379-7.506,5.63V31.9l-4.5-3.379L2.25,34.148v9.382h3V35.649l4.5-3.377,4.5,3.377v7.881h3V23.64l4.5-3.377,4.5,3.377v19.89h3v-31.9l4.5-3.377,4.5,3.377v31.9h3V10.13Z",
  transform: "translate(-2.25 -4.5)",
  fill: "#ac1ede"
});

var SvgIncreaseLevel = function SvgIncreaseLevel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.029,
    height: 39.029,
    viewBox: "0 0 39.029 39.029",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIncreaseLevel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/increase-level.c8dbe168.svg";
export { ForwardRef as ReactComponent };